import React from 'react'

const PositionLever = React.lazy(() => import('pages/PositionLevel/PositionLevel'));

const PositionLeverRoutes = [
    {
        path: '/position-level',
        exact: true,
        name: 'Danh sách cấp nhân viên',
        function: 'MD_POSITIONLEVEL_VIEW',
        component: PositionLever,
    },
]

export default PositionLeverRoutes
